import { render, staticRenderFns } from "./CustomizedList.vue?vue&type=template&id=e2addb22&scoped=true"
import script from "./CustomizedList.vue?vue&type=script&lang=js"
export * from "./CustomizedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2addb22",
  null
  
)

export default component.exports